'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtMap', [
	'$timeout',
	function ($timeout) {
		return {
			restrict: 'A',
			scope: {
				pmtMap: '@',
				markers: '@',
				dragendCallback: '&',
				forceReload: '='
			},
			link: function (scope, element, attrs) {
				// remember that if you load a map that is under ng-show it will be having timing issues. use ng-if instead.

				const iconUrl = {
					pinmeto: 'img/map-icons/Blue_MasterData.svg',
					facebook: 'img/map-icons/Gray_Facebook.svg',
					google: 'img/map-icons/Gray_Google.svg',
					foursquare: 'img/map-icons/Gray_FourSquare.svg',
					bing: 'img/map-icons/Gray_Bing.svg'
				};
				const iconMiniUrl = {
					pinmeto: 'img/map-icons/Black_MasterData.svg',
					facebook: 'img/map-icons/Gray_Facebook.svg',
					google: 'img/map-icons/Gray_Google.svg',
					foursquare: 'img/map-icons/Gray_FourSquare.svg',
					bing: 'img/map-icons/Gray_Bing.svg'
				};

				const networks = ['facebook', 'google', 'foursquare', 'bing'];

				let map,
					extraMarkers = [],
					allMarkers = [],
					markers = L.markerClusterGroup({ spiderfyDistanceMultiplier: 3, maxClusterRadius: 1 }),
					setMarker = function (markerConf) {
						let marker;
						let miniMode = element[0].offsetWidth < 150;
						let iconOptions = {};
						if (miniMode) {
							iconOptions.iconUrl = iconMiniUrl[markerConf.iconType];
							iconOptions.iconSize = [32, 46];
							iconOptions.iconAnchor = [13, 42];
							iconOptions.popupAnchor = [0, 44];
						} else {
							iconOptions.iconUrl = iconUrl[markerConf.iconType];
							iconOptions.iconSize = [44, 68];
							iconOptions.iconAnchor = [22, 67];
							iconOptions.popupAnchor = [0, 70];
						}
						let icon = L.icon(iconOptions);

						markerConf.location = markerConf.location || {};
						markerConf.location.lat = markerConf.location.lat || 0;
						markerConf.location.lon = markerConf.location.lon || 0;
						if (markerConf.iconType === 'pinmeto') {
							marker = L.marker([markerConf.location.lat, markerConf.location.lon], {
								icon: icon
							}).addTo(map);
						} else if (networks.indexOf(markerConf.iconType) > -1) {
							marker = L.marker([markerConf.location.lat, markerConf.location.lon], { icon: icon });
							markers.addLayer(marker);
						} else {
							marker = L.marker([markerConf.location.lat, markerConf.location.lon]); //.addTo(map);
						}

						if (markerConf.prio) {
							marker.setZIndexOffset(1000 - markerConf.prio); // prio 1 higher than 2 etc.
						}
						if (markerConf.draggable) {
							marker.dragging.enable();
							marker.on('dragend', function (dragEvent) {
								marker = dragEvent.target;
								const position = marker.getLatLng();
								const coords = {};
								coords.lon =
									parseFloat(
										parseFloat(position.lng).toPrecision(
											String(Math.abs(parseInt(position.lng))).length + 6
										)
									) || 0;
								coords.lat =
									parseFloat(
										parseFloat(position.lat).toPrecision(
											String(Math.abs(parseInt(position.lat))).length + 6
										)
									) || 0;
								map.panTo([coords.lat || 0, coords.lon || 0]);
								scope.dragendCallback({ location: coords });
							});
						}

						allMarkers.push(marker);

						return marker;
					},
					addMarkers = function (markerObj) {
						setMarker(markerObj);

						if (extraMarkers && extraMarkers.length > 0) {
							extraMarkers.forEach(function (marker) {
								setMarker(marker);
							});
						}
					},
					invalidateSize = function () {
						if (map) {
							map.invalidateSize();
						}
					},
					initMap = function (markerObj) {
						angular.element(document).ready(function () {
							let mapElement = element[0],
								markerLocation = markerObj.location,
								mapWidth = element[0].offsetWidth,
								miniMode = mapWidth < 150,
								zoom = miniMode ? 10 : 15;

							try {
								map = L.map(mapElement, {
									center: [markerLocation.lat || 0, markerLocation.lon || 0],
									zoom: zoom,
									zoomControl: false,
									attributionControl: !miniMode,
									doubleClickZoom: !miniMode,
									scrollWheelZoom: false,
									dragging: !miniMode,
									disableClusteringAtZoom: 2
								});
							} catch (err) {
								if (err && err.message !== 'Map container is already initialized.') {
									throw err;
								}
							}

							if (!miniMode) {
								new L.Control.Zoom({ position: 'bottomright' }).addTo(map);
							}

							L.tileLayer(
								'https://api.mapbox.com/styles/v1/pinmeto/cjciu9mq68i172so6paoyiuhe/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGlubWV0byIsImEiOiJvZC1QTVpnIn0.AhgCfYhZzLpmcqZYCRoZDA',
								{
									maxZoom: 20,
									minZoom: 4
								}
							).addTo(map);
							addMarkers(markerObj);
							map.panTo([markerObj?.location?.lat || 0, markerObj?.location?.lon || 0]);
						});
					};

				const updateMap = markerObj => {
					allMarkers.forEach(function (marker) {
						// remove old markers
						map.removeLayer(marker);
						markers.removeLayer(marker);
					});
					addMarkers(markerObj);

					if (extraMarkers && extraMarkers.length > 0) {
						map.addLayer(markers);
					}
					const zoomLevel = map.getZoom() || 13;
					map.setZoom(zoomLevel);
					map.panTo([markerObj?.location?.lat || 0, markerObj?.location?.lon || 0]);
					invalidateSize();
				};

				const initOrUpdate = markerObj => {
					if (map) {
						updateMap(markerObj);
					} else {
						initMap(markerObj);
					}
				};

				scope.$watch(
					function () {
						return element[0].offsetParent;
					},
					function (newVal /*, oldVal*/) {
						// is not null anymore when is shown.
						if (newVal !== null) {
							invalidateSize();
						}
					}
				);

				scope.$on('$destroy', function () {
					map = null;
				});

				attrs.$observe('pmtMap', function (newVal, oldVal) {
					if (newVal == null || newVal === oldVal || newVal === '') {
						return;
					}
					let markerObj = scope.$eval(newVal);
					scope.markerObj = markerObj;
					markerObj.prio = 1;
					initOrUpdate(markerObj);
				});

				attrs.$observe('markers', function (newVal, oldVal) {
					if (newVal == null || newVal === oldVal) {
						return;
					}
					extraMarkers = scope.$eval(newVal);
					if (extraMarkers && extraMarkers.length && extraMarkers.length > 0) {
						$timeout(function () {
							initOrUpdate(scope.markerObj);
						}, 200); // delay hack to extra markers to not interfere with map init.
					}
				});

				scope.$watch(
					'forceReload',
					function (newVal /*, oldVal*/) {
						if (newVal && newVal.reload) {
							initOrUpdate(scope.markerObj);
						}
					},
					true
				);
			}
		};
	}
]);
